<div class="container">
  <app-simple-string-value-accessor label="Email"
                                    [formControl]="emailForm"
                                    required="true"></app-simple-string-value-accessor>
  <div class="actions">
    <button mat-raised-button
            action-button
            [disabled]="!emailForm.valid"
            class="width-100 action-button"
            color="primary"
            type="button"
            [action]="editEmail.bind(this)">
      Edytuj email
    </button>
    <button mat-stroked-button
            action-button
            class="width-100 action-button"
            color="primary"
            type="button"
            [action]="deleteEmail.bind(this)">
      Usuń
    </button>
  </div>
</div>

